module.exports = __webpack_public_path__ + "5b78fc91a93d9626ff2bb8c805037110.png";